// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e13fdb43","703":"d4015711","787":"bd1e1046"}[chunkId] + ".chunk.js";
};